export const features = {
  reports: {
    noResults: {
      imgSrc: 'assets/no-locations.svg',
      title: 'REPORTS.NO_RESULT',
    },
  },
  walls: {
    noResults: {
      imgSrc: 'assets/no-locations.svg',
      title: 'WALLS_LIST.NO_RESULTS.TITLE',
    },
    noData: {
      imgSrc: 'assets/no-locations.svg',
      title: 'WALLS_LIST.NO_DATA.TITLE',
    },
  },
}